import { Component, inject, signal } from "@angular/core";
import { TextService } from "../services/text.service";
import { AsyncPipe } from "@angular/common";
import {
  AlertComponent as TtAlertComponent,
  ModalComponent as TtModalComponent,
  ButtonComponent as TtButtonComponent,
} from "@ticket-team-com/tt-component-library";
import { ActivatedRoute, Router } from "@angular/router";
import { ReceiptService } from "../services/receipt.service";
import { ReceiptPdfService } from "../services/receipt-pdf.service";
import { OrderService } from "../services/order.service";
import { Receipt } from "../models/receipt";
import { TtcurrencyPipe } from "../pipes/ttcurrency.pipe";

@Component({
  selector: "app-confirmation",
  templateUrl: "./confirmation.component.html",
  styleUrls: ["./confirmation.component.css"],
  imports: [AsyncPipe, TtAlertComponent, TtModalComponent, TtButtonComponent, TtcurrencyPipe],
})
export class ConfirmationComponent {
  public textService = inject(TextService);
  private receiptService = inject(ReceiptService);
  private receiptPdfService = inject(ReceiptPdfService);
  private orderService = inject(OrderService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  receipt = signal<Receipt | null>(null);

  openReceipt() {
    const guid =
      this.orderService.getTransactionGuid() ??
      this.route.snapshot.queryParamMap.get("guid");

    if (!guid) return;

    this.receiptService.getReceipt(guid).subscribe((r) => this.receipt.set(r));
  }

  closeReceipt() {
    this.receipt.set(null);
  }

  downloadReceipt() {
    const r = this.receipt();
    if (r) this.receiptPdfService.download(r);
  }

  placeNewOrder() {
    this.router.navigate(["/"], {
      queryParams: { tableId: this.orderService.getTableId() },
    });
  }
}
